import React from "react";
import { Users, UserCheck, ClipboardList, CalendarIcon } from "lucide-react";
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { useGetFieldForceSummary } from "../../hooks";

const FieldForceDashboard: React.FC = () => {
  const { data: fieldForceSummary, isLoading } = useGetFieldForceSummary();
  
  // KPI Cards configuration using QuickStatsCard
  const fieldForceKpiCards = [
    {
      title: "Total Field Force Technicians",
      count: fieldForceSummary?.totalFieldForce || 0,
      trendSummary: "Total technicians and supervisors in the system",
      trendDirection: "up" as const,
      icon: <Users className="h-8 w-8 text-blue-500" />
    },
    {
      title: "Active Technicians",
      count: fieldForceSummary?.activeFieldForce || 0,
      trendSummary: "Technicians currently available for assignments",
      trendDirection: "up" as const,
      icon: <UserCheck className="h-8 w-8 text-green-500" />
    },
    {
      title: "On Assignment",
      count: fieldForceSummary?.fieldForceOnWork || 0,
      trendSummary: "Technicians currently working on service orders",
      trendDirection: "up" as const,
      icon: <ClipboardList className="h-8 w-8 text-orange-500" />
    },
    {
      title: "Unavailable Technicians",
      count: fieldForceSummary?.unavailableFieldForce || 0,
      trendSummary: "Technicians currently unavailable or off-duty",
      trendDirection: "down" as const,
      icon: <CalendarIcon className="h-8 w-8 text-red-500" />
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {isLoading ? (
        // Loading skeleton
        [...Array(4)].map((_, index) => (
          <div key={index} className="bg-white rounded-lg p-6 shadow-sm animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-full"></div>
          </div>
        ))
      ) : (
        // Actual cards
        fieldForceKpiCards.map((card, index) => (
          <QuickStatsCard
            key={index}
            title={card.title}
            count={card.count}
            trendSummary={card.trendSummary}
            trendDirection={card.trendDirection}
            icon={card.icon}
          />
        ))
      )}
    </div>
  );
};

export default FieldForceDashboard;